const LoadScript = () => {
  const scripts = [
    "js/main.js",
    "js/authentication-main.js",
    "libs/@popperjs/core/umd/popper.min.js",
    "libs/bootstrap/js/bootstrap.bundle.min.js",
    // "js/defaultmenu.min.js",
    "libs/node-waves/waves.min.js",
    "js/sticky.js",
    "libs/simplebar/simplebar.min.js",
    // "js/simplebar.js",
    "libs/@tarekraafat/autocomplete.js/autoComplete.min.js",
    "libs/@simonwep/pickr/pickr.es5.min.js",
    "libs/flatpickr/flatpickr.min.js",
  ];
  scripts.map((src) => {
    const fullSrc = `${process.env.REACT_APP_PUBLIC_URL}assets/${src}`;
    const scriptExists = document.querySelector(`script[src="${fullSrc}"]`);
    if (scriptExists) return null;
    const script = document.createElement("script");
    script.src = fullSrc;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
    return script;
  });
  return <></>;
};

export default LoadScript;
